export default "__VITE_ASSET__9ba7c0c5__"